<template>
  <div style="padding-top: 4rem; padding-bottom: 4rem">
    <p
      align="center"
      style="
        font-family: Arial, Helvetica, sans-serif;
        font-size: 2.5rem;
        font-weight: 800;
        color: #1c3e8e;
      "
    >
      Portafolio de Experiencia
    </p>
    <divider-component />
    <div align="center">
      <p
        style="
          width: 50%;
          font-family: Arial, Helvetica, sans-serif;
          font-weight: 400;
        "
        align="center"
      >
        Bienvenidos a nuestro Portafolio de Experiencia, donde cada proyecto es
        un testimonio de nuestra dedicación, innovación y compromiso con la
        calidad. Hemos participado en una gran variedad de proyectos, tanto en
        construcción como en remodelación.
        <br />
        <br />
        Te invitamos a revisar nuestro historial de proyectos.
      </p>
    </div>
  </div>

  <div>
    <h2 align="center" class="title" style="color: #ffb762">QUERETARO</h2>
  </div>
  <time-line-component :array1="Queretaro" :color="'#FFB762'" />
  <div>
    <h2 align="center" class="title" style="color: red">OAXACA</h2>
  </div>
  <time-line-component :array1="Oaxaca" :color="'red'" />
  <div>
    <h2 align="center" class="title" style="color: #37419e">HIDALGO</h2>
  </div>
  <time-line-component :array1="Hidalgo" :color="'#37419E'" />
</template>
<script>
import DividerComponent from '@/components/DividerComponent.vue';
import TimeLineComponent from '@/components/TimeLineComponent.vue';
import ApiPortafolio from '@/Api/ApiPortafolio';
export default {
  components: { DividerComponent, TimeLineComponent },
  data: () => ({
    Oaxaca: [],
    Hidalgo: [],
    Queretaro: [],
  }),
  mounted() {
    this.GetElementosHidalgo();
    this.GetElementosOaxaca();
    this.GetElementosQueretaro();
  },
  methods: {
    async GetElementosHidalgo() {
      await ApiPortafolio.getAllByEstado('HIDALGO')
        .then((response) => {
          
          this.Hidalgo = response.data;
          this.Hidalgo.sort((a, b) => Number(a.fecha) - Number(b.fecha));
        })
        .catch((error) => {});
    },
    async GetElementosOaxaca() {
      await ApiPortafolio.getAllByEstado('OAXACA')
        .then((response) => {
          this.Oaxaca = response.data;
        })
        .catch((error) => {});
    },
    async GetElementosQueretaro() {
      await ApiPortafolio.getAllByEstado('QUERETARO')
        .then((response) => {
          this.Queretaro = response.data;
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped>
@media (min-width: 1200px) {
  /* Ajusta este valor según el breakpoint que desees */
  .my-timeline-card {
    margin-left: 100px;
    margin-right: 100px;
  }
}

@media (max-width: 1199px) {
  .my-timeline-card {
    margin: 0;
  }
}

.title {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
}

.txtdata {
  font-family: Arial, Helvetica, sans-serif;
  font-size: large;
  font-weight: 600;
}
/* Viñetas personalizadas */
</style>
